<!--component for listing phrases to doctor usage at chat-->
<template>
  <div class="flex align-center py1 border-bottom border-gray-4" @click="usePhrase">
    <div class="col-3 flex-none">
      <div class="flex input-addon">
        <input v-model="hashtag" type="text" class="col-12 semibold order-1 no-border" readonly>
        <div class="flex-none semibold no-border">{{phrase.company ? '##' : '#'}}</div>
      </div>
    </div>
    <div class="col-9 ml3 mr1">
      <input v-model="value" type="text" class="col-12 no-border" readonly>
    </div>
    <div class="flex-none flex align-center">
      <v-button variant="icon">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <g stroke="#00A1D4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 8.5l-7.5 7L7 13"/>
            <path d="M23.5 12c0 6.352-5.15 11.5-11.5 11.5C5.647 23.5.5 18.352.5 12S5.647.5 12 .5C18.35.5 23.5 5.648 23.5 12z"/>
          </g>
        </svg>
      </v-button>
    </div>
  </div>
</template>

<script>

import Button from '@/components/Button.vue'

export default {
  name: 'PhraseListItem',
  components: {'v-button': Button },
  props: {
    chat: Object,
    phrase: {},
  },
  data () {
    return {

      hashtag: this.phrase.hashtag,
      value: this.phrase.phrase,
    };
  },
  methods: {
    usePhrase() {
       this.$store.commit('SET_CHAT_INPUT', {
        chatId: this.chat.chatId,
        input: this.value,
      });
    },
  }
}

</script>

<style scoped>
.input-addon > div {
  padding: var(--space-1);
  padding-right: 0;
  color: var(--dark-blue);
  font-size: var(--h5);
  border: 1px solid var(--gray-3);
  border-right: 0;
  margin-right: -1px;
  z-index: 1;
  background-color: #fff;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.input-addon > input {
  padding-left: 0;
}

.input-addon > input:focus ~ div {
  border-color: var(--dark-blue)
}

.no-border {
  border: 0px !important;
}

</style>
